import React from "react";
import { Link } from "react-router-dom";
import LogoImg from "../../assets/images/logo.png";
import LogoMobileImg from "../../assets/images/mobile-logo.png";
import useMediaQuery from "../../hooks/useMediaQuery";
import styles from "./style.module.css";

const Logo = ({ logoImg = LogoImg, link = "/" }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  return (
    <div className={styles.logo_container}>
      <Link to={link} className={styles.logo}>
        <img src={isMobile ? LogoMobileImg : logoImg} alt="logo" />
      </Link>
    </div>
  );
};

export default Logo;
